import { render, staticRenderFns } from "./main-button.component.vue?vue&type=template&id=03ad47cd&scoped=true&"
import script from "./main-button.component.vue?vue&type=script&lang=ts&"
export * from "./main-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./main-button.component.vue?vue&type=style&index=0&id=03ad47cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ad47cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
